import React from 'react'
import { Backdrop, CircularProgress, Box } from '@mui/material'

interface LoadingOverlayProps {
  loading: boolean
  children: React.ReactNode
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  loading,
  children,
}) => {
  return (
    <Box sx={{ position: 'relative' }}>
      {children}

      {loading && (
        <Backdrop
          open={loading}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            zIndex: 9999,
          }}
        >
          <CircularProgress color="primary" />
        </Backdrop>
      )}
    </Box>
  )
}

export default LoadingOverlay
